import { getTopicList } from '../../datafetchers/HomePage';
import { getScreenName } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';

export const topicFilter = [
  {
    name: 'All',
    key: 'all',
  },
  {
    name: 'Planning Pregnancy',
    key: 'ttc',
  },
  {
    name: 'Pregnant',
    key: 'pregnant',
  },
  {
    name: 'Infant(0-1 Years)',
    key: 'infant',
  },
  {
    name: 'Toddlers(1-3 Years)',
    key: 'toddler',
  },
];

export const filterClickHandler = async (key, mutate, setShowLoader) => {
  setShowLoader(true);
  const response = await getTopicList(key);
  const initialData = {
    tagsDetails: response?.tagsDetails,
    selectedFilter: key,
  };
  setShowLoader(false);
  mutate(initialData, false);
};
export const fireFilterEvent = (name, section_name, section_id) => {
  fireEvent({
    category: 'selected_filter',
    screen_name: getScreenName(),
    name: name,
    page_url: window.location.href,
    section_name: section_name,
    section_id: section_id,
  });
};
